import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('eyb_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Assessment API
export const assessmentApi = {
  getQuestions: (path) => api.get(`/assessment/questions/${path}`),
  getChecklist: (path) => api.get(`/assessment/checklist/${path}`),
  calculatePath: (data) => api.post('/assessment/calculate-path', data),
  createAssessment: (data) => api.post('/assessment', data),
  getAssessment: (id) => api.get(`/assessment/${id}`),
  updateAssessment: (id, data) => api.patch(`/assessment/${id}`, data),
  getUserAssessments: () => api.get('/assessments')
};

// Auth API
export const authApi = {
  requestPasswordReset: (email) => api.post('/auth/forgot-password', { email })
};

// Admin API
export const adminApi = {
  getAssessments: (params) => api.get('/admin/assessments', { params }),
  exportCsv: () => api.get('/admin/export-csv')
};

export default api;
